import axiosInstance from './apis';


export const getCustomers = async(customer) =>{
  return await axiosInstance.post(`/settings/get-accounts-by-search`,customer)
}

export const getCustomersList = async(customer) =>{
  return await axiosInstance.post(`/settings/get-customers`,customer)
}

export const getCustomersGroup = async() =>{
  return await axiosInstance.post(`/sales/get-customer-groups`)
}

export const getLocations = async() =>{
  return await axiosInstance.post(`/settings/get-locations`)
}

export const getEmployees = async() =>{
  return await axiosInstance.post(`/settings/get-employees`)
}

export const getCustomersCode = async() =>{
  return await axiosInstance.post(`/sales/get-customer-code`)
}

export const saveCustomerGroup = async(payload) =>{
  return await axiosInstance.post(`/sales/save-customer-group`,payload)
}
export const getCustomerGroup = async() =>{
  return await axiosInstance.post(`/sales/get-customer-groups`)
}


export const saveCustomers = async (payload) => {
    const hasFiles =
      Array.isArray(payload.document_url) &&
      payload.document_url.some((f) => f instanceof File);

    if (hasFiles) {
      const formData = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (key === "acc_type") {
          formData.append(key, JSON.stringify(value));
        } 
        else if (key === "document_url" && Array.isArray(value)) {
          value.forEach((file) => {
            if (file instanceof File) {
              formData.append("document_url", file);
            }
          });
        } 
        else {
          formData.append(key, value);
        }
      });

      return axiosInstance.post(`/accounts/save-account`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    // 🔴 JSON fallback ONLY when no files exist
    return axiosInstance.post(`/accounts/save-account`, payload);
  };

  export const saveSupplier = async (payload) => {
  const hasFiles =
    Array.isArray(payload.document_url) &&
    payload.document_url.some((f) => f.originFileObj instanceof File);

  if (hasFiles) {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      if (key === "acc_type") {
        formData.append(key, JSON.stringify(value));
      }
      else if (key === "document_url" && Array.isArray(value)) {
        value.forEach((file) => {
          if (file.originFileObj instanceof File) {
            formData.append("document_url", file.originFileObj);
          }
        });
      }
      else {
        formData.append(key, value);
      }
    });

    return axiosInstance.post(`/accounts/save-account`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  // JSON fallback
  return axiosInstance.post(`/accounts/save-account`, payload);
};





// export const saveCustomers = async(payload) =>{
//   return await axiosInstance.post(`/accounts/save-account`,payload)
// }






